<script context="module">
    import {writable} from "svelte/store";

    export const session = writable({
        loggedIn: false,
        user: ""
    });
</script>